import { render, staticRenderFns } from "./MappedSelectionField.vue?vue&type=template&id=88e3d21c&scoped=true&"
import script from "./MappedSelectionField.vue?vue&type=script&lang=ts&"
export * from "./MappedSelectionField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e3d21c",
  null
  
)

export default component.exports